import { FC } from 'react';

import { ScrollingCarousel } from '@/ux-legacy/components/Carousel';

type TabsBarProps = {
  tabOptions: { name: string; value: string; count?: number; nonClickable?: boolean }[];
  onTabClick: (value: string) => void;
  activeNoBg?: boolean;
  isSelected: string;
  isEditMode?: boolean;
  borderNeed?: boolean;
  isClickAble?: boolean;
};

const TabsBar002: FC<TabsBarProps> = ({
  tabOptions,
  onTabClick,
  activeNoBg = false,
  isSelected,
  isClickAble = true,
}) => {
  return (
    <div
      className={`w-fit max-w-full text-base font-medium text-center text-gray-600 bg-gray-100 rounded-md p-1
        `}
    >
      <div className="w-fit  max-w-full  flex overflow-x-auto ">
        <ScrollingCarousel>
          {tabOptions.map((item) => {
            return (
              <a key={item.name} className=" text-gray-400">
                <button
                  className={`'p-2 px-4 flex flex-row gap-x-2 items-center leading-none'
                    ${
                      isSelected === item.value
                        ? `inline-block px-2 py-2 md:py-auto  ${
                            activeNoBg ? 'bg-transparent' : 'bg-white '
                          } p-0.5 text-black  rounded-md active font-medium clickable-item-text`
                        : `inline-block px-2 py-2 md:py-auto  dark:hover:text-gray-300 clickable-item-text ${
                            item?.nonClickable
                              ? 'cursor-not-allowed opacity-50'
                              : 'hover:text-gray-600 hover:border-gray-300'
                          }`
                    }
                       
                  `}
                  onClick={(e) => {
                    if (item?.nonClickable === undefined && isClickAble) {
                      e.stopPropagation();
                      onTabClick(item.value);
                    }
                  }}
                  disabled={!isClickAble}
                >
                  {item.name}
                  {/* {!isEditMode && <span className=" ml-1 text-slate-500">{item.count}</span>} */}
                </button>
              </a>
            );
          })}
        </ScrollingCarousel>
      </div>
    </div>
  );
};

export default TabsBar002;
